import { useState } from 'react';
import { CircleCheckBig, Folder, TriangleAlert } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useTheme } from '@/lib/contexts/theme-context';
import { useTranslation } from 'react-i18next';

export const FORM_REPORT_FINALIZE_ID = 'form-report-finalize';

/**
 * Formulaire de finalisation d'un rapport de procédure (brouillon)
 * Affiche le récapitulatif des jetons, le dossier de destination et un avertissement
 */
export default function FormReportFinalize({ onSubmit, tokenCostPdf = 2, folderName = '' }) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const isHorodateme = theme.slug === 'horodateme';
    const [appendCertificates, setAppendCertificates] = useState(true);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.({ appendCertificates });
    };

    return (
        <form id={FORM_REPORT_FINALIZE_ID} onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-5">
            {/* Success Card - "Plus qu'une étape !" */}
            <div className="mb-6 bg-success/15 rounded-2xl p-5 flex flex-col items-center text-center">
                <div className="w-14 h-14 bg-secondary rounded-full flex items-center justify-center mb-3">
                    <CircleCheckBig className="h-8 w-8 text-foreground" />
                </div>
                <h3 className="text-lg text-foreground mb-3">{t('procedures:plusQuUneEtape')}</h3>
                {!isHorodateme && (
                    <p className="text-sm text-foreground">
                        {t('procedures:finaliserLeRapportConsommera')} {tokenCostPdf} jeton{tokenCostPdf > 1 ? 's' : ''}
                    </p>
                )}
            </div>

            {/* Dossier de destination */}
            {folderName && (
                <div className="bg-card rounded-2xl p-4 mb-4 border border-border flex items-center gap-3">
                    <div className="bg-muted rounded-lg h-10 w-10 flex items-center justify-center shrink-0">
                        <Folder className="h-5 w-5 text-muted-foreground" />
                    </div>
                    <div className="flex-1 text-left">
                        <p className="text-xs text-muted-foreground mb-0.5">{t('procedures:dossierDeDestination')}</p>
                        <p className="text-sm text-foreground font-medium">{folderName}</p>
                    </div>
                </div>
            )}

            {/* Option certificats (photos + vidéos) */}
            <div className="bg-card rounded-2xl p-4 mb-4 border border-border flex items-center justify-between gap-3">
                <div className="flex-1">
                    <p className="text-sm text-foreground font-medium">{t('procedures:collerLesCertificatsPhotosEtVideos')}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                        {t('procedures:collerTousLesCertificatsPhotosEtVideosA')}
                    </p>
                </div>
                <Switch checked={appendCertificates} onCheckedChange={setAppendCertificates} />
            </div>

            {/* Avertissement */}
            <div className="bg-warning/10 rounded-2xl p-4 border border-warning">
                <div className="flex gap-3">
                    <TriangleAlert className="h-5 w-5 text-warning shrink-0 mt-0.5" />
                    <div>
                        <p className="text-[13px] text-foreground font-medium mb-1">{t('procedures:aLireAvantDeFinaliser')}</p>
                        <p className="text-[13px] text-foreground">
                            {t('procedures:unRapportFinaliseNePeutPlusEtreModifie')}
                        </p>
                    </div>
                </div>
            </div>
        </form>
    );
}
